var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"no-padding no-margin"},[(_vm.route==`/superadmin/providers`)?_c('Table'):_vm._e(),(_vm.route==`/superadmin/providers/add-new`)?_c('AddNewForm'):_vm._e(),(_vm.route==`/superadmin/providers/provider`)?_c('SingleForm'):_vm._e(),(_vm.route==`/superadmin/providers/invite-provider`)?_c('InviteForm'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }